<app-tab-toolbar [tabId]="'ownership'" [selectedYear]="selectedYear" [saveDisabled]="!hasChanges && !isOwnershipDetailsCarriedForward"
  [showOtherMeasurement]="true" [otherMeasurement]="otherMeasurement"
  [showKeywordsToggle]="true" [keywordsVisible]="showKeywords"
  (keywordsVisibleChange)="showKeywords = $event"
  (yearChange)="onYearChange($event)" (otherMeasurementChange)="onOtherMeasurementChange($event)"
  (save)="onSave()">
  @if (showYearWarning) {
    <div class="year-warning">
      <mat-icon>warning</mat-icon>
      @if (isOwnershipDetailsCarriedForward) {
        <span>There is no data for the selected year. Some fields are shown from a previous year.</span>
      } @else {
        <span>There is no data for the selected year</span>
      }
    </div>
  }
</app-tab-toolbar>

<div class="ownership-content" [formGroup]="form" [appReadOnlyTab]="'ownership'">

  <!-- Stock Class Configuration -->
  @if (isStockClassConfigCarriedForward) {
    <div class="year-warning">
      <mat-icon>info</mat-icon>
      <span>Stock class configuration carried forward from a previous year. Shares and voting data must be entered for this year.</span>
    </div>
  }
  <section class="section-container nrg-border-radius-second-level">
    <div class="section-header">
      <span>Stock Classes</span>
    </div>
    <div class="section-content">
      <div class="stock-class-row">
          <div class="stock-class-fields">
            <div class="stock-field">
              <label>Coefficient</label>
              <select formControlName="firstClassStockCoefficientId" class="ht-input stock-input-coefficient">
                <option [ngValue]="null">(None)</option>
                @for (coeff of stockCoefficients; track coeff.id) {
                  <option [ngValue]="coeff.id">{{ coeff.value }}</option>
                }
              </select>
            </div>
            <div class="stock-field">
              <label>Category</label>
              <select formControlName="firstClassStockCategoryId" class="ht-input stock-input-coefficient">
                <option [ngValue]="null">(None)</option>
                @for (cat of stockCategories; track cat.id) {
                  <option [ngValue]="cat.id">{{ cat.name }}</option>
                }
              </select>
            </div>
            <div class="stock-field">
              <label>Type</label>
              <select formControlName="firstClassStockType" class="ht-input stock-input-text">
                <option value="">(None)</option>
                <option value="Listed">Listed</option>
                <option value="Unlisted">Unlisted</option>
              </select>
            </div>
          </div>
          <div class="stock-class-fields">
            <div class="stock-field">
              <label>Coefficient</label>
              <select formControlName="secondClassStockCoefficientId" class="ht-input stock-input-coefficient">
                <option [ngValue]="null">(None)</option>
                @for (coeff of stockCoefficients; track coeff.id) {
                  <option [ngValue]="coeff.id">{{ coeff.value }}</option>
                }
              </select>
            </div>
            <div class="stock-field">
              <label>Category</label>
              <select formControlName="secondClassStockCategoryId" class="ht-input stock-input-coefficient">
                <option [ngValue]="null">(None)</option>
                @for (cat of stockCategories; track cat.id) {
                  <option [ngValue]="cat.id">{{ cat.name }}</option>
                }
              </select>
            </div>
            <div class="stock-field">
              <label>Type</label>
              <select formControlName="secondClassStockType" class="ht-input stock-input-text">
                <option value="">(None)</option>
                <option value="Listed">Listed</option>
                <option value="Unlisted">Unlisted</option>
              </select>
            </div>
          </div>
          <div class="stock-class-fields">
            <div class="stock-field">
              <label>Coefficient</label>
              <select formControlName="thirdClassStockCoefficientId" class="ht-input stock-input-coefficient">
                <option [ngValue]="null">(None)</option>
                @for (coeff of stockCoefficients; track coeff.id) {
                  <option [ngValue]="coeff.id">{{ coeff.value }}</option>
                }
              </select>
            </div>
            <div class="stock-field">
              <label>Category</label>
              <select formControlName="thirdClassStockCategoryId" class="ht-input stock-input-coefficient">
                <option [ngValue]="null">(None)</option>
                @for (cat of stockCategories; track cat.id) {
                  <option [ngValue]="cat.id">{{ cat.name }}</option>
                }
              </select>
            </div>
            <div class="stock-field">
              <label>Type</label>
              <select formControlName="thirdClassStockType" class="ht-input stock-input-text">
                <option value="">(None)</option>
                <option value="Listed">Listed</option>
                <option value="Unlisted">Unlisted</option>
              </select>
            </div>
          </div>
        </div>
      </div>
  </section>

  <!-- Board of Directors / Supervisory Board -->
  <div class="board-section">
    <h3 class="section-title">{{ companyBoardType === 0 ? 'Board of Directors' : 'Supervisory Board' }}</h3>

    @if (boardDataSource.data.length === 0) {
      <div class="no-data-message">No data available</div>
    } @else {
    <div class="table-wrapper">
      <table mat-table [dataSource]="boardDataSource" class="ownership-table" formArrayName="boardRows" matSort #boardSort="matSort" matSortActive="name" matSortDirection="asc" (matSortChange)="onBoardSort($event)">

        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index" class="cell-index" (click)="toggleRowHighlight(row)">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">{{ row.directorFullName }}</td>
        </ng-container>

        <ng-container matColumnDef="firstClassSharesPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>C.A %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="firstClassSharesPercentage" class="ht-input">
            @if (otherMeasurement && isDifferent(row.firstClassSharesPercentage, getOtherBoardMember(row.directorId)?.firstClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.firstClassSharesPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="firstClassShares">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>1st Class Shares</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="firstClassShares" class="ht-input">
            @if (otherMeasurement && isDifferent(row.firstClassShares, getOtherBoardMember(row.directorId)?.firstClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherBoardMember(row.directorId)?.firstClassShares) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="secondClassSharesPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>C.B %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="secondClassSharesPercentage" class="ht-input">
            @if (otherMeasurement && isDifferent(row.secondClassSharesPercentage, getOtherBoardMember(row.directorId)?.secondClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.secondClassSharesPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="secondClassShares">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>2nd Class Shares</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="secondClassShares" class="ht-input">
            @if (otherMeasurement && isDifferent(row.secondClassShares, getOtherBoardMember(row.directorId)?.secondClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherBoardMember(row.directorId)?.secondClassShares) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="thirdClassSharesPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>C.C %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="thirdClassSharesPercentage" class="ht-input">
            @if (otherMeasurement && isDifferent(row.thirdClassSharesPercentage, getOtherBoardMember(row.directorId)?.thirdClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.thirdClassSharesPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="thirdClassShares">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>3rd Class Shares</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="thirdClassShares" class="ht-input">
            @if (otherMeasurement && isDifferent(row.thirdClassShares, getOtherBoardMember(row.directorId)?.thirdClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherBoardMember(row.directorId)?.thirdClassShares) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="votingRightPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>V.R. %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="votingRightPercentage" class="ht-input ht-input-calculated" readonly>
            @if (otherMeasurement && isDifferent(row.votingRightPercentage, getOtherBoardMember(row.directorId)?.votingRightPercentage)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.votingRightPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="votingRights">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Voting Rights</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [decimals]="0" formControlName="votingRights" class="ht-input ht-input-calculated" readonly>
            @if (otherMeasurement && isDifferent(row.votingRights, getOtherBoardMember(row.directorId)?.votingRights)) {<span class="ht-other">{{ formatOtherInt(getOtherBoardMember(row.directorId)?.votingRights) }}</span>}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="boardDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: boardDisplayedColumns;" [class.row-highlighted]="row.highlighted"></tr>
      </table>
    </div>
    }
  </div>

  <!-- Management Board (Dual mode only) -->
  @if (companyBoardType !== 0) {
    <div class="board-section">
      <h3 class="section-title">Management Board</h3>

      @if (managementDataSource.data.length === 0) {
        <div class="no-data-message">No data available</div>
      } @else {
      <div class="table-wrapper">
        <table mat-table [dataSource]="managementDataSource" class="ownership-table" formArrayName="managementRows" matSort #managementSort="matSort" matSortActive="name" matSortDirection="asc" (matSortChange)="onManagementSort($event)">

          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let row; let i = index" class="cell-index" (click)="toggleRowHighlight(row)">{{ i + 1 }}</td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let row">{{ row.directorFullName }}</td>
          </ng-container>

          <ng-container matColumnDef="firstClassSharesPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>C.A %</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="firstClassSharesPercentage" class="ht-input">
              @if (otherMeasurement && isDifferent(row.firstClassSharesPercentage, getOtherBoardMember(row.directorId)?.firstClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.firstClassSharesPercentage) }}</span>}
            </td>
          </ng-container>

          <ng-container matColumnDef="firstClassShares">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>1st Class Shares</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="firstClassShares" class="ht-input">
              @if (otherMeasurement && isDifferent(row.firstClassShares, getOtherBoardMember(row.directorId)?.firstClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherBoardMember(row.directorId)?.firstClassShares) }}</span>}
            </td>
          </ng-container>

          <ng-container matColumnDef="secondClassSharesPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>C.B %</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="secondClassSharesPercentage" class="ht-input">
              @if (otherMeasurement && isDifferent(row.secondClassSharesPercentage, getOtherBoardMember(row.directorId)?.secondClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.secondClassSharesPercentage) }}</span>}
            </td>
          </ng-container>

          <ng-container matColumnDef="secondClassShares">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>2nd Class Shares</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="secondClassShares" class="ht-input">
              @if (otherMeasurement && isDifferent(row.secondClassShares, getOtherBoardMember(row.directorId)?.secondClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherBoardMember(row.directorId)?.secondClassShares) }}</span>}
            </td>
          </ng-container>

          <ng-container matColumnDef="thirdClassSharesPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>C.C %</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="thirdClassSharesPercentage" class="ht-input">
              @if (otherMeasurement && isDifferent(row.thirdClassSharesPercentage, getOtherBoardMember(row.directorId)?.thirdClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.thirdClassSharesPercentage) }}</span>}
            </td>
          </ng-container>

          <ng-container matColumnDef="thirdClassShares">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>3rd Class Shares</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat formControlName="thirdClassShares" class="ht-input">
              @if (otherMeasurement && isDifferent(row.thirdClassShares, getOtherBoardMember(row.directorId)?.thirdClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherBoardMember(row.directorId)?.thirdClassShares) }}</span>}
            </td>
          </ng-container>

          <ng-container matColumnDef="votingRightPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>V.R. %</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="votingRightPercentage" class="ht-input ht-input-calculated" readonly>
              @if (otherMeasurement && isDifferent(row.votingRightPercentage, getOtherBoardMember(row.directorId)?.votingRightPercentage)) {<span class="ht-other">{{ formatOther(getOtherBoardMember(row.directorId)?.votingRightPercentage) }}</span>}
            </td>
          </ng-container>

          <ng-container matColumnDef="votingRights">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Voting Rights</th>
            <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
              <input type="text" inputmode="numeric" appNumberFormat [decimals]="0" formControlName="votingRights" class="ht-input ht-input-calculated" readonly>
              @if (otherMeasurement && isDifferent(row.votingRights, getOtherBoardMember(row.directorId)?.votingRights)) {<span class="ht-other">{{ formatOtherInt(getOtherBoardMember(row.directorId)?.votingRights) }}</span>}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="boardDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: boardDisplayedColumns;" [class.row-highlighted]="row.highlighted"></tr>
        </table>
      </div>
      }
    </div>
  }

  <!-- Keywords — Board Shares -->
  @if (showKeywords) {
    <div class="board-section keywords-section" formGroupName="keywords">
      <div class="keywords-header">
        <span>Keywords</span>
      </div>
      <div class="keywords-fields">
        <app-keyword-input name="boardShares" label="Board Shares" />
      </div>
    </div>
  }

  <!-- Executive Management -->
  <div class="board-section">
    <h3 class="section-title">Executive Management</h3>

    @if (executiveDataSource.data.length === 0) {
      <div class="no-data-message">No data available</div>
    } @else {
    <div class="table-wrapper">
      <table mat-table [dataSource]="executiveDataSource" class="ownership-table" formArrayName="executiveRows" matSort #executiveSort="matSort" matSortActive="name" matSortDirection="asc" (matSortChange)="onExecutiveSort($event)">

        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index" class="cell-index" (click)="toggleRowHighlight(row)">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Full Name</th>
          <td mat-cell *matCellDef="let row">{{ row.directorFullName }}</td>
        </ng-container>

        <ng-container matColumnDef="firstClassSharesPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>C.A %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="firstClassSharesPercentage" class="ht-input">
            @if (otherMeasurement && isDifferent(row.firstClassSharesPercentage, getOtherExecutiveMember(row.directorId)?.firstClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.firstClassSharesPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="firstClassShares">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>1st Class Shares</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="firstClassShares" class="ht-input">
            @if (otherMeasurement && isDifferent(row.firstClassShares, getOtherExecutiveMember(row.directorId)?.firstClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherExecutiveMember(row.directorId)?.firstClassShares) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="secondClassSharesPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>C.B %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="secondClassSharesPercentage" class="ht-input">
            @if (otherMeasurement && isDifferent(row.secondClassSharesPercentage, getOtherExecutiveMember(row.directorId)?.secondClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.secondClassSharesPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="secondClassShares">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>2nd Class Shares</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="secondClassShares" class="ht-input">
            @if (otherMeasurement && isDifferent(row.secondClassShares, getOtherExecutiveMember(row.directorId)?.secondClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherExecutiveMember(row.directorId)?.secondClassShares) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="thirdClassSharesPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>C.C %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="thirdClassSharesPercentage" class="ht-input">
            @if (otherMeasurement && isDifferent(row.thirdClassSharesPercentage, getOtherExecutiveMember(row.directorId)?.thirdClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.thirdClassSharesPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="thirdClassShares">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>3rd Class Shares</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="thirdClassShares" class="ht-input">
            @if (otherMeasurement && isDifferent(row.thirdClassShares, getOtherExecutiveMember(row.directorId)?.thirdClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherExecutiveMember(row.directorId)?.thirdClassShares) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="votingRightPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>V.R. %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="votingRightPercentage" class="ht-input ht-input-calculated" readonly>
            @if (otherMeasurement && isDifferent(row.votingRightPercentage, getOtherExecutiveMember(row.directorId)?.votingRightPercentage)) {<span class="ht-other">{{ formatOther(getOtherExecutiveMember(row.directorId)?.votingRightPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="votingRights">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Voting Rights</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [decimals]="0" formControlName="votingRights" class="ht-input ht-input-calculated" readonly>
            @if (otherMeasurement && isDifferent(row.votingRights, getOtherExecutiveMember(row.directorId)?.votingRights)) {<span class="ht-other">{{ formatOtherInt(getOtherExecutiveMember(row.directorId)?.votingRights) }}</span>}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="executiveDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: executiveDisplayedColumns;" [class.row-highlighted]="row.highlighted"></tr>
      </table>
    </div>
    }
  </div>

  <!-- Large Shareholders -->
  <div class="board-section">
    <h3 class="section-title">Large Shareholders</h3>

    @if (isLargeShareholdersCarriedForward) {
      <div class="year-warning">
        <mat-icon>info</mat-icon>
        <span>Large shareholders carried forward from a previous year. Shares and voting data must be entered for this year.</span>
      </div>
    }

    @if (shareholderDataSource.data.length === 0 && !isLargeShareholdersCarriedForward) {
      <div class="no-data-message">No data available</div>
    } @else {
    <div class="table-wrapper">
      <table mat-table [dataSource]="shareholderDataSource" class="ownership-table" formArrayName="shareholderRows" matSort #shareholderSort="matSort" matSortActive="name" matSortDirection="asc" (matSortChange)="onShareholderSort($event)">

        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index" class="cell-index" (click)="toggleRowHighlight(row)">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            <span class="name-cell">
              <a [routerLink]="['/large-shareholders/edit', row.largeShareholderId]" [queryParams]="{ fromCompany: companyId, fromCompanyName: companyName(), year: selectedYear }" class="shareholder-link-btn" title="Edit large shareholder" (click)="$event.stopPropagation()">
                <mat-icon>open_in_new</mat-icon>
              </a>
              {{ row.largeShareholderName }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="firstClassSharesPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>C.A %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="firstClassSharesPercentage" class="ht-input">
            @if (otherMeasurement && isDifferent(row.firstClassSharesPercentage, getOtherShareholder(row)?.firstClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherShareholder(row)?.firstClassSharesPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="firstClassShares">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>1st Class Shares</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="firstClassShares" class="ht-input">
            @if (otherMeasurement && isDifferent(row.firstClassShares, getOtherShareholder(row)?.firstClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherShareholder(row)?.firstClassShares) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="secondClassSharesPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>C.B %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="secondClassSharesPercentage" class="ht-input">
            @if (otherMeasurement && isDifferent(row.secondClassSharesPercentage, getOtherShareholder(row)?.secondClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherShareholder(row)?.secondClassSharesPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="secondClassShares">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>2nd Class Shares</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="secondClassShares" class="ht-input">
            @if (otherMeasurement && isDifferent(row.secondClassShares, getOtherShareholder(row)?.secondClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherShareholder(row)?.secondClassShares) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="thirdClassSharesPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>C.C %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [min]="0" [max]="100" [decimals]="2" formControlName="thirdClassSharesPercentage" class="ht-input">
            @if (otherMeasurement && isDifferent(row.thirdClassSharesPercentage, getOtherShareholder(row)?.thirdClassSharesPercentage)) {<span class="ht-other">{{ formatOther(getOtherShareholder(row)?.thirdClassSharesPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="thirdClassShares">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>3rd Class Shares</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat formControlName="thirdClassShares" class="ht-input">
            @if (otherMeasurement && isDifferent(row.thirdClassShares, getOtherShareholder(row)?.thirdClassShares)) {<span class="ht-other">{{ formatOtherInt(getOtherShareholder(row)?.thirdClassShares) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="votingRightPercentage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>V.R. %</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="votingRightPercentage" class="ht-input ht-input-calculated" readonly>
            @if (otherMeasurement && isDifferent(row.votingRightPercentage, getOtherShareholder(row)?.votingRightPercentage)) {<span class="ht-other">{{ formatOther(getOtherShareholder(row)?.votingRightPercentage) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="votingRights">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Voting Rights</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" inputmode="numeric" appNumberFormat [decimals]="0" formControlName="votingRights" class="ht-input ht-input-calculated" readonly>
            @if (otherMeasurement && isDifferent(row.votingRights, getOtherShareholder(row)?.votingRights)) {<span class="ht-other">{{ formatOtherInt(getOtherShareholder(row)?.votingRights) }}</span>}
          </td>
        </ng-container>

        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Category</th>
          <td mat-cell *matCellDef="let row">{{ row.categoryName }}</td>
        </ng-container>

        <ng-container matColumnDef="subCategory">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sub-Category</th>
          <td mat-cell *matCellDef="let row">{{ row.subCategoryName }}</td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            @if (!isReadOnly()) {
              <button mat-icon-button color="warn" (click)="onDeleteShareholder(row)" class="delete-btn">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="shareholderDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: shareholderDisplayedColumns;" [class.row-highlighted]="row.highlighted"></tr>
      </table>
    </div>
    }

    @if (!isReadOnly()) {
      <div class="table-actions">
        <button mat-raised-button color="primary" (click)="onInsertShareholder()">Add</button>
        @if (selectedShareholders.length > 0) {
          <button mat-raised-button color="primary" type="button" class="nrg-destructive-primary-button" (click)="onDeleteSelectedShareholders()">
            <mat-icon>delete</mat-icon>
            Delete selected ({{ selectedShareholders.length }})
          </button>
        }
      </div>
    }
  </div>

  <!-- Keywords — Large Shareholders -->
  @if (showKeywords) {
    <div class="board-section keywords-section" formGroupName="keywords">
      <div class="keywords-header">
        <span>Keywords</span>
      </div>
      <div class="keywords-fields">
        <app-keyword-input name="largestShareholder" label="Largest Shareholder" />
        <app-keyword-input name="totalShares" label="Total Shares" />
      </div>
    </div>
  }

  <!-- Capital Shares & Summary -->
  <div class="bottom-sections">

    <!-- Capital Shares & Voting Rights -->
    <div class="capital-section">
      <div class="capital-grid" [formGroup]="form" [appReadOnlyTab]="'ownership'">
        <!-- Title header -->
        <div class="ht-label"></div>
        <div class="ht-title-header" style="grid-column: span 6">Capital Shares &amp; Voting Rights</div>
        <div class="ht-label"></div>

        <!-- Group headers -->
        <div class="ht-label"></div>
        <div class="ht-group-header ht-group-header--no-top" style="grid-column: span 2">1st Class</div>
        <div class="ht-group-header ht-group-header--no-top" style="grid-column: span 2">2nd Class</div>
        <div class="ht-group-header ht-group-header--no-top" style="grid-column: span 2">3rd Class</div>
        <div class="ht-label"></div>

        <!-- Column sub-headers -->
        <div class="ht-label"></div>
        <div class="ht-col-header">%</div><div class="ht-col-header">Shares</div>
        <div class="ht-col-header">%</div><div class="ht-col-header">Shares</div>
        <div class="ht-col-header">%</div><div class="ht-col-header">Shares</div>
        <div class="ht-col-header">Total</div>

        <!-- Capital Share row -->
        <div class="ht-label">Capital Share</div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="firstClassCapitalSharePercentage" class="ht-input ht-input-calculated" readonly>
          @if (otherMeasurement && isDifferent(form.get('firstClassCapitalSharePercentage')?.value, otherData?.firstClassCapitalSharePercentage)) {<span class="ht-other">{{ formatOther(otherData?.firstClassCapitalSharePercentage) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="firstClassTotalShares" class="ht-input">
          @if (otherMeasurement && isDifferent(form.get('firstClassTotalShares')?.value, otherData?.firstClassTotalShares)) {<span class="ht-other">{{ formatOtherInt(otherData?.firstClassTotalShares) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="secondClassCapitalSharePercentage" class="ht-input ht-input-calculated" readonly>
          @if (otherMeasurement && isDifferent(form.get('secondClassCapitalSharePercentage')?.value, otherData?.secondClassCapitalSharePercentage)) {<span class="ht-other">{{ formatOther(otherData?.secondClassCapitalSharePercentage) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="secondClassTotalShares" class="ht-input">
          @if (otherMeasurement && isDifferent(form.get('secondClassTotalShares')?.value, otherData?.secondClassTotalShares)) {<span class="ht-other">{{ formatOtherInt(otherData?.secondClassTotalShares) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="thirdClassCapitalSharePercentage" class="ht-input ht-input-calculated" readonly>
          @if (otherMeasurement && isDifferent(form.get('thirdClassCapitalSharePercentage')?.value, otherData?.thirdClassCapitalSharePercentage)) {<span class="ht-other">{{ formatOther(otherData?.thirdClassCapitalSharePercentage) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat formControlName="thirdClassTotalShares" class="ht-input">
          @if (otherMeasurement && isDifferent(form.get('thirdClassTotalShares')?.value, otherData?.thirdClassTotalShares)) {<span class="ht-other">{{ formatOtherInt(otherData?.thirdClassTotalShares) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat class="ht-input ht-input-calculated" readonly [value]="capitalShareTotal">
        </div>

        <!-- Voting Rights row -->
        <div class="ht-label">Voting Rights</div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="firstClassTotalVotingRightsPercentage" class="ht-input ht-input-calculated" readonly>
          @if (otherMeasurement && isDifferent(form.get('firstClassTotalVotingRightsPercentage')?.value, otherData?.firstClassTotalVotingRightsPercentage)) {<span class="ht-other">{{ formatOther(otherData?.firstClassTotalVotingRightsPercentage) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat [decimals]="0" formControlName="firstClassTotalVotingRights" class="ht-input ht-input-calculated" readonly>
          @if (otherMeasurement && isDifferent(form.get('firstClassTotalVotingRights')?.value, otherData?.firstClassTotalVotingRights)) {<span class="ht-other">{{ formatOtherInt(otherData?.firstClassTotalVotingRights) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="secondClassTotalVotingRightsPercentage" class="ht-input ht-input-calculated" readonly>
          @if (otherMeasurement && isDifferent(form.get('secondClassTotalVotingRightsPercentage')?.value, otherData?.secondClassTotalVotingRightsPercentage)) {<span class="ht-other">{{ formatOther(otherData?.secondClassTotalVotingRightsPercentage) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat [decimals]="0" formControlName="secondClassTotalVotingRights" class="ht-input ht-input-calculated" readonly>
          @if (otherMeasurement && isDifferent(form.get('secondClassTotalVotingRights')?.value, otherData?.secondClassTotalVotingRights)) {<span class="ht-other">{{ formatOtherInt(otherData?.secondClassTotalVotingRights) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat [decimals]="2" formControlName="thirdClassTotalVotingRightsPercentage" class="ht-input ht-input-calculated" readonly>
          @if (otherMeasurement && isDifferent(form.get('thirdClassTotalVotingRightsPercentage')?.value, otherData?.thirdClassTotalVotingRightsPercentage)) {<span class="ht-other">{{ formatOther(otherData?.thirdClassTotalVotingRightsPercentage) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat [decimals]="0" formControlName="thirdClassTotalVotingRights" class="ht-input ht-input-calculated" readonly>
          @if (otherMeasurement && isDifferent(form.get('thirdClassTotalVotingRights')?.value, otherData?.thirdClassTotalVotingRights)) {<span class="ht-other">{{ formatOtherInt(otherData?.thirdClassTotalVotingRights) }}</span>}
        </div>
        <div class="ht-cell">
          <input type="text" inputmode="numeric" appNumberFormat class="ht-input ht-input-calculated" readonly [value]="votingRightsTotal">
        </div>

        <!-- Free Float row -->
        <div class="ht-label">Free Float</div>
        <div class="ht-cell">
          <input type="text" class="ht-input ht-input-calculated" [class.ht-input-negative]="isFreeFloatFirstClassNegative" readonly [value]="freeFloatFirstClass">
          @if (otherMeasurement && otherFreeFloatValue('firstClassSharesPercentage') !== null) {<span class="ht-other">{{ formatFreeFloat(otherFreeFloatValue('firstClassSharesPercentage')) }}</span>}
        </div>
        <div class="ht-cell-empty"></div>
        <div class="ht-cell">
          <input type="text" class="ht-input ht-input-calculated" [class.ht-input-negative]="isFreeFloatSecondClassNegative" readonly [value]="freeFloatSecondClass">
          @if (otherMeasurement && otherFreeFloatValue('secondClassSharesPercentage') !== null) {<span class="ht-other">{{ formatFreeFloat(otherFreeFloatValue('secondClassSharesPercentage')) }}</span>}
        </div>
        <div class="ht-cell-empty"></div>
        <div class="ht-cell">
          <input type="text" class="ht-input ht-input-calculated" [class.ht-input-negative]="isFreeFloatThirdClassNegative" readonly [value]="freeFloatThirdClass">
          @if (otherMeasurement && otherFreeFloatValue('thirdClassSharesPercentage') !== null) {<span class="ht-other">{{ formatFreeFloat(otherFreeFloatValue('thirdClassSharesPercentage')) }}</span>}
        </div>
        <div class="ht-cell-empty"></div>
        <div class="ht-cell-empty"></div>
      </div>
    </div>

  </div>

  <!-- Comments -->
  <section class="section-container nrg-border-radius-second-level comments-section">
    <div class="section-header">
      <span>Comments</span>
    </div>
    <div class="section-content">
      <mat-form-field appearance="fill" class="form-field">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" rows="3"></textarea>
      </mat-form-field>
    </div>
  </section>

</div>
